// dependencies
import { Map } from "immutable";
import React from "react";

import AjaxInput from "../../components/Inputs/AjaxInput/compatibility";
// components
import Checkbox from "../../components/Inputs/Checkbox";
import DatePicker from "../../components/Inputs/DatePicker";
import Input from "../../components/Inputs/InputText";

import PropTypes from "../../lib/prop-types";

// props
const propTypes = {
	onChange: PropTypes.func,
	_type: PropTypes.string,
	name: PropTypes.string,
	props: PropTypes.object,
	input: PropTypes.node,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Map)]),
	type: PropTypes.string,
	options: PropTypes.array,
	isClearable: PropTypes.bool,
};

const InputProxy = ({
	_type = null,
	name,
	onChange = () => {},
	props,
	input = null,
	value = "",
	type = null,
	options = null,
	isClearable = false,
	placeholder = undefined,
	info = undefined,
	inputId = undefined,
	labelId = undefined,
}) => {
	/*
        Pulls in the appropriate input.
    */

	if (input) {
		return input;
	}

	let renderedInput = <div />;

	switch (_type) {
		case "text":
			renderedInput = (
				<Input
					info={info}
					name={name}
					onChange={onChange}
					value={value}
					placeholder={placeholder}
					inputId={inputId}
				/>
			);
			break;

		case "picker":
			renderedInput = (
				<AjaxInput
					name={name}
					onChange={onChange}
					value={value}
					type={type}
					isClearable={isClearable}
					options={options}
					placeholder={placeholder}
					inputId={inputId}
				/>
			);
			break;

		case "datepicker":
			renderedInput = (
				<DatePicker
					dateEngine="moment"
					name={name}
					{...props}
					onChange={onChange}
					value={value}
					hasIcon
					inputId={inputId}
				/>
			);
			break;

		case "checkbox":
			renderedInput = <Checkbox name={name} onChange={onChange} value={value} id={inputId} labelId={labelId} />;
			break;

		default:
			renderedInput = <div />;
			break;
	}

	return renderedInput;
};

InputProxy.propTypes = propTypes;

export default InputProxy;
